import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const BellFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.19458 0C6.4767 0 4.82918 0.682425 3.61446 1.89715C2.39974 3.11187 1.71731 4.75939 1.71731 6.47727V11.5295L0.283675 13.6886C0.111838 13.9536 0.0143701 14.2598 0.00147075 14.5754C-0.0114286 14.8909 0.0607146 15.2041 0.210351 15.4822C0.359988 15.7603 0.581617 15.993 0.852045 16.1561C1.12247 16.3191 1.43176 16.4065 1.74754 16.4091H14.6416C14.9594 16.408 15.2711 16.321 15.5434 16.1573C15.8158 15.9936 16.0389 15.7592 16.1889 15.479C16.339 15.1989 16.4104 14.8833 16.3957 14.5659C16.381 14.2484 16.2808 13.9408 16.1055 13.6757L14.6719 11.5295V6.47727C14.6719 4.75939 13.9894 3.11187 12.7747 1.89715C11.56 0.682425 9.91246 0 8.19458 0Z"
        fill="currentColor"
      />
      <path
        d="M8.19466 18.9997C8.72994 18.9991 9.25189 18.8327 9.68877 18.5234C10.1256 18.2141 10.456 17.7771 10.6344 17.2725H5.75488C5.93331 17.7771 6.26367 18.2141 6.70054 18.5234C7.13742 18.8327 7.65937 18.9991 8.19466 18.9997Z"
        fill="currentColor"
      />
    </svg>
  )
})

BellFilled.displayName = 'BellFilled'
